import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';

import Slider from './slider';
import PitListTeam from './pitListTeam';
import PitAdvancedListTeam from './pitAdvancedListTeam';

class Content extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        // console.log('content=', this.props);
        const { content } = this.props;

        const { pitSlider } = content;

        return (
            <div className={styles.col_wbf}>
                <div className={styles.space30} />
                <Chip
                    id="55018"
                    type="recommend"
                    title="国际智库轮播图"
                    groupName="正文"
                    content={pitSlider}
                    translate="handlePitSliderData">
                    <Slider />
                </Chip>
                <div className={styles.space30} />
                <div>
                    <div className={styles.col_w1000}>
                        <Chip
                            id="225737"
                            type="recommend"
                            title="智库频道-研究团队-轮播图下方研究员列表"
                            groupName="国际智库"
                            content={content}>
                            <PitListTeam />
                        </Chip>
                        <div className={styles.space30} />
                        <Chip
                            id="195852"
                            type="recommend"
                            title="智库频道-研究团队-高级研究员列表"
                            groupName="国际智库"
                            content={content}>
                            <PitAdvancedListTeam />
                        </Chip>
                    </div>
                </div>
            </div>
        );
    }
}

export default Content;
